import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/how-to-fix-a-leaking-roof-from-inside.html")({
  beforeLoad: () => { throw redirect({ to: "/emergency-roof-leak-repair", statusCode: 301 }); },
});
